export default {
  postureReport: "姿勢報告",
  postureData: "姿勢數據",
  postureDataContrast: "姿勢數據對比",
  postureRiskContrast: "姿勢風險對比",
  postureDataTrend: "姿勢數據趨勢",
  postureRiskTrend: "姿勢風險趨勢",
  postureLogData: "姿勢日誌數據",
  lateralhead: "橫向頭部傾斜",
  unevenshoulder: "肩膀不平",
  scoliosis: "脊柱側彎",
  unevenhip: "骨盆側傾",
  xleg: "X 形腿",
  oleg: "O 形腿",
  roundedshoulder: "圓肩",
  kneehyperextension: "膝蓋過度伸展",
  trunkforwardtilt: "躯干倾角（矢状面）",
  trunklateraltilt: "躯干倾角（冠状面）",
  ankleheelleft: "足跟内外翻（左）",
  ankleheelright: "足跟内外翻（右）",
  forwardhead: "頭部前傾",
  toTheLeft: "（左）",
  toTheRight: "（右）",
  bracketsLeft: "（L）",
  bracketsRight: "（R）",
  bracketsNormal: "（正常）",
  leg: "腿",
  legLeft: "腿（L）",
  legRight: "腿（R）",
  riskAssessment: "風險評估",
  muscleState: "肌肉狀態",
  muscleStateDesc: "未發現異常肌肉狀況",
  testTime: "測試時間",
  hRisk: "高",
  mRisk: "中",
  lRisk: "低",
  item: "項目",
  degree: "度",
  percent: "%",
  mm: "mm",
  moireImage: "雲紋圖",
  lAbnormalRisk: "L 風險",
  mAbnormalRisk: "M 風險",
  hAbnormalRisk: "高風險",
  highRisk: "高風險",
  riskAnalysis: "風險分析",
  conclusionRecommendation: "結論與建議",
  solution: "解決方案",
  movePosition: "點擊點以移動位置",
  confirmTheClose: "尚未保存，確認關閉嗎？",
  closeInfo: "尚未保存，確認關閉嗎？",
  share: "分享",
  front: "前面",
  side: "側面",
  back: "後面",
  otherSide: "另一側",
  points: "點",
  angle: "角度",
  name: "名稱",
  gender: "性別",
  male: "男性",
  female: "女性",
  age: "年齡",
  year: "歲",
  height: "身高",
  weight: "體重",
  time: "時間",
  patientId: "就診號",
  save: "保存",
  saveModify: "保存修改",
  print: "打印",
  cancel: "取消",
  zoomIn: "放大",
  zoomOut: "縮小",
  ok: "好的",
  return: "返回",
  empty: "",
  unknown: "未知",
  succeedToCopy: "複製成功",
  succeedToSave: "保存成功",
  headForwardDistance: "頭部前移距離",
  pelvisForwardTilt: "骨盆前傾角",
  wristHipDistanceLeft: "腕髖距離（左）",
  wristHipDistanceRight: "腕髖距離（右）",
  wristHipDistanceRight: "腕髖距離（右）",
  evaluator: "評估",
  reportDate: "報告日",
  introduction: "簡介",
  doctorIntroDefault: "專業領域：復健醫學、體態評估與矯正 | 從年限：5年以上 | 適用於運動損傷復健、姿勢矯正、疼痛管理",
  recoveryLog: "康復日誌",
  returnToReport: "返回報告",
  loading: "數據加載中...",
  showToolbox: "顯示工具箱",
  hideToolbox: "隱藏工具箱",
};

